<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="vx-col w-full my-2">
          <vs-input
            v-model="model.holdersOfTheRightToSignName"
            name="holdersOfTheRightToSignName"
            :label="$t('HoldersOfTheRightToSignName')"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('holdersOfTheRightToSignName')"
            >{{ errors.first("holdersOfTheRightToSignName") }}</span
          >
        </div>
        <div class="vx-col w-full my-2">
          <vs-input
            v-model="model.economicCode"
            name="EconomicCode"
            :label="$t('EconomicCode')"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('EconomicCode')"
            >{{ errors.first("EconomicCode") }}</span
          >
        </div>
        <div class="vx-col w-full my-2">
          <vs-checkbox
            @click="isHasMember($event)"
            :checked="model.agentBranchInfo"
            class="w-10/12"
            >{{ $t("hasBranch") }}
          </vs-checkbox>
        </div>

        <vs-button
          type="filled"
          class="float-right mb-4 mt-4"
          @click.prevent="submitForm"
          :disabled="!model.holdersOfTheRightToSignName || !model.economicCode"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    holdersOfTheRightToSignName: {
      required: "لطفا صاحبان حق امضا را وارد نمایید.",
    },
    EconomicCode: {
      required: "لطفا کد اقتصادی را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  props: {
    show: { default: false },
    party:{
      type:Number,
    }

  },
  data() {
    return {
      departman: "",
      popupTitle: "",
      disabled: false,
      model: {
      agentBranchInfo:0
    },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createLegalAgentFromCustomer: "legal/createAgentFromCustomer",
    }),
    isHasMember(val) {
      if (val.target.checked) this.model.agentBranchInfo = 1;
      else this.model.agentBranchInfo = 0;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.partyId=this.party
            this.createLegalAgentFromCustomer(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditDepartmans";
        else this.popupTitle = "CreateAgent";
      }
      this.$validator.reset();
    },
  },
};
</script>
